<template>
  <div class="banner-wrap">
    <a class="v-d-first-view" href="https://rsv.pbf.org.tw" target="_blank">
      <img class="deco-img flag-deco" src="@/assets/img/index/deco_flag.png" />
      <img class="deco-img pink-arc-deco" src="@/assets/img/index/bg_kv_pink.svg" />
      <img class="deco-img balloon-bird-deco" src="@/assets/img/index/deco_balloonbird.png" />

      <!-- <div class="g-content v-d-first-view__content">
      <div class="text"> -->
      <!-- <div class="louder">
          <img class="louder__deco" src="@/assets/img/index/deco_stick_left.png" />
          <p class="louder__text">
            <span class="louder__text__split">守護小腳ㄚ・跨出大人生</span>
          </p>

          <img class="louder__deco" src="@/assets/img/index/deco_stick_right.png" />
        </div> -->

      <!-- <p class="desc">
          <span class="desc__text__mobile"
            >基金會結合各界的協助，為早產兒及其家庭點燃信心與希望，推廣早產防與治的觀念與知識，讓每個早產兒有接受適當醫療的機會</span
          >
          <span class="desc__text">基金會結合各界的協助，為早產兒及其家庭點燃信心與希望</span
          ><span class="desc__text">推廣早產防與治的觀念與知識</span
          ><span class="desc__text">讓每個早產兒有接受適當醫療的機會</span>
        </p> -->
      <!-- </div>
      <div class="main-services">
        <main-service-box v-for="data of servicesBox" :key="data.label" :data="data" />
      </div>
    </div> -->
    </a>
    <div class="main-services">
      <main-service-box v-for="data of servicesBox" :key="data.label" :data="data" />
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import MainServiceBox from '@/components/Home/MainServiceBox.vue';
import iconMedical from '@/assets/icon/icon_medical.svg';
import iconTrack from '@/assets/icon/icon_track.svg';
import iconLecture from '@/assets/icon/icon_lecture.svg';
import iconHealtheducation from '@/assets/icon/icon_healtheducation.svg';

export default defineComponent({
  name: 'FirstView',
  components: {
    MainServiceBox,
  },
  setup() {
    const servicesBox = [
      {
        label: '醫療補助',
        icon: iconMedical,
        route: {
          name: 'medical-allowance',
        },
        bgColor: '#FF9FA6',
      },
      {
        label: '極低出生體重追蹤',
        icon: iconTrack,
        route: {
          name: 'discharged-low-weight-checking',
        },
        bgColor: '#D3A9E0',
      },
      {
        label: '活動/課程',
        icon: iconLecture,
        route: {
          name: 'activity-lessons',
          query: {
            page: 1,
          },
        },
        bgColor: '#7FD3B6',
      },
      {
        label: '衛教百寶箱',
        icon: iconHealtheducation,
        route: {
          name: 'health-education',
        },
        bgColor: '#83D0E6',
      },
    ];
    return {
      servicesBox,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '~@/styles/utils/_rwd.scss';
.banner-wrap {
  position: relative;
}
.v-d-first-view {
  display: block;
  @extend %bg-img-normal;
  background-size: 100% auto;
  background-image: url('~@/assets/img/banner/mob_kv_20250307.png');
  padding-bottom: 50%;
  // position: relative;
  margin-top: 85px;
  @media screen and (min-width: $sm-pc) {
    margin-top: 130px;
  }

  &__content.g-content {
    height: 100%;
  }

  // override default
}

.text {
  // @include position(center);
  // @include padding(20px);
  width: 100%;

  @include flex(center, center, column);
}
.louder {
  @include flex(center);

  &__deco {
    width: 36px;
  }

  &__text {
    width: 276px;
    text-align: center;

    &__split {
      @include font-style($c-white, 24, bold, 2px, 36px);
      text-align: justify;
      text-align-last: left;
      display: block;
    }

    @media screen and (min-width: $mobile) {
      @include font-size(26);
    }
    @media screen and (min-width: $portrait) {
      @include font-size(45);
      letter-spacing: 4.5px;
      font-weight: 500;
    }
  }
}

.desc {
  margin-top: 20px;
  width: 276px;
  &__text__mobile {
    @include font-style($c-white, 14, 400, normal, 22px);
  }

  &__text {
    display: none;
  }
}

.main-services {
  display: none;
}

@media screen and (min-width: $portrait) {
  .v-d-first-view {
    @extend %bg-img-normal;
    background-image: url('~@/assets/img/banner/web_kv_20250307.jpg');
    padding-bottom: 36%;
    &__content {
      height: 100%;
    }
  }

  .louder {
    @include flex();
    font-weight: 700;
    margin-left: -40px;

    &__deco {
      width: 15px;

      @media screen and (min-width: $portrait) {
        width: 36px;
      }
    }

    &__text {
      width: auto;
      text-align: left;

      color: $c-white;
      @include font-size(20);
      margin: 0 4px;
      letter-spacing: 2px;

      @media screen and (min-width: $mobile) {
        @include font-size(26);
      }
      @media screen and (min-width: $portrait) {
        @include font-size(45);
        letter-spacing: 4.5px;
        font-weight: 700;
      }
    }
  }

  .text {
    @include position(tl, 50%, 0);
    transform: translateY(-50%);
    @include flex(flex-start, flex-start, column);
  }

  .desc {
    width: 100%;
    margin-top: 12px;

    &__text {
      display: block;
      @include font-style($c-white, 16, 400, 1.2px, 28px);

      &__mobile {
        display: none;
      }
    }
  }

  .flag-deco {
    @include position(tr, 135px, -15px);
  }

  .pink-arc-deco {
    @include position(bl, 100%, 0);
    z-index: 10;
  }

  .balloon-bird-deco {
    @include position(bl, 0, 0);
    z-index: 10;
    transform: translateY(20%);
  }
}

@media screen and (min-width: $tablet) {
  .main-services {
    max-width: 768px;
    @include flex(space-between);
    width: 100%;

    @include position(bl, -30px, 50%);
    z-index: 10;
    transform: translateX(-50%);
  }
}

@media screen and (min-width: $sm-pc) {
  .v-d-first-view {
    // @include padding(0 40px);

    // &__content {
    //   @include padding(300px 0px 40px);
    // }
  }

  .main-services {
    max-width: 768px;
  }
}
@media screen and (min-width: $pc) {
  .v-d-first-view {
    // &__content {
    //   @include padding(200px 0px 40px);
    // }

    // override default
  }

  .louder {
    margin-left: -60px;

    &__deco {
      width: 60px;
    }

    &__text {
      &__split {
        @include font-style($c-white, 45, bold, 2px, 65px);
      }
    }
  }

  .desc {
    margin-top: 60px;

    &__text {
      @include font-style($c-white, 20, 400, 2px, 28px);
    }
  }

  .main-services {
    max-width: 1390px;
    bottom: -40px;

    :v-deep .c-main-service-box {
      // &:first-child {
      width: 300px;
      // }
    }
  }
}
</style>

<style lang="scss">
@import '~@/styles/utils/_rwd.scss';

@media screen and (min-width: $pc) {
  .main-services {
    max-width: 1390px;

    .c-main-service-box {
      &:first-child {
        width: 300px;
      }

      &:nth-child(2) {
        width: 337px;
      }

      &:nth-child(3) {
        width: 300px;
      }
      &:last-child {
        width: 300px;
      }
    }
  }
}
</style>
